import { formatNumber } from './commonFormats';

function pluralizeWordWithCount(word: string, number: number): string {
  return pluralizeWord(word, number !== 1);
}
function pluralizeWord(word: string, plural: boolean): string {
  if (!plural) {
    return word;
  }

  switch (word.toLowerCase()) {
    // +s
    case 'action':
    case 'app':
    case 'day':
    case 'bottleneck':
    case 'contributor':
    case 'command':
    case 'change':
    case 'credit':
    case 'event':
    case 'group':
    case 'invocation':
    case 'key':
    case 'license':
    case 'line':
    case 'localization':
    case 'member':
    case 'module':
    case 'project':
    case 'runner':
    case 'run':
    case 'suite':
    case 'webhook':
      return `${word}s`;

    // +es
    case 'branch':
    case 'status':
      return `${word}es`;
    default:
      return word;
  }
}
const nItems = (n: number | 'all' | 'All' | 'Unlimited', fullName: string) => {
  const pieces = fullName.split(' ');
  pieces[pieces.length - 1] = pluralizeWord(pieces[pieces.length - 1], typeof n === 'string' || n > 1);

  return `${typeof n === 'string' ? n : formatNumber(n, 0)} ${pieces.join(' ')}`;
};

export { nItems, pluralizeWordWithCount };
